<div>
  <app-page-header title="Logging In" [showBack]="false"></app-page-header>

  <div class="d-flex justify-content-center align-items-center my-5">
    <app-large-spinner></app-large-spinner>
  </div>
</div>
